module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/kestutis/Projects/fifth-avenue/wp-content/themes/5th/node_modules/axios/index.js
// module id = 14
// module chunks = 0